import { lazy } from 'react';

const CustomRecertificationTestStatics = lazy(() => import('./RecertificationTestStatistics.js'));

export default CustomRecertificationTestStatics;
